module.exports = __webpack_public_path__ + "img/voucher-icon_blue.05dc7f0a.svg";